import moment from "moment";
import { Card } from "./card";

const ArticleCard = ({ article }) => {
  return (
    <Card as="article" href={`/blog/${article.attributes.slug}`}>
      <Card.Title>
        {article.attributes.title || ''}
      </Card.Title>
      <Card.Eyebrow as="time" dateTime={article.publishedAt} decorate>
        {moment(article.attributes.publishedAt).format('MMM Do, YYYY')}
      </Card.Eyebrow>
      <Card.Description>{article.attributes.description}</Card.Description>
      <Card.Cta>Read article</Card.Cta>
    </Card>
  )
}

export default ArticleCard;
